import type {
	CustomItem,
	DropGFGPatchType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropGFGPatches = (
	item: Item | CustomItem
): item is DropGFGPatchType => {
	return !!(
		item &&
		item.__typename === 'Drop_Custom_Component' &&
		item.name === 'GFG_Patches_And_Sections'
	);
};
